<template>
  <section class="content white flex-grow">
    <table-failed-oppgjor :limit="50" :large="true"/>
  </section>
</template>

<script>
import TableFailedOppgjor from './TableFailedOppgjor'

export default {
  name: 'PageFailedOppgjor',
  components: {
    TableFailedOppgjor
  },
  created () {
    if (!this.hasAccess('accounting')) {
      this.$router.push('/dashboard')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard/PageFailedOppgjor.vue